module.exports = __webpack_public_path__ + "img/bigou-logo.ee413658.png";